import {Alert} from "@material-tailwind/react";
import {useEffect, useState} from "react";
import { ethers} from "ethers";
import abi from "../utils/BiddingSystem.json"

const BidWinner = () => {
    const contractAddress = "0x94e80029F904233ED38783d93A99A1591Fb5422E";
    const contractABI = abi.abi;
    const [winner, setWinner] = useState();
    const getWinner = async (e) => {
        try {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const deployedContract = new ethers.Contract(contractAddress, contractABI, signer);
            //const winner = await deployedContract.getWinner();
            setWinner(winner);
        } catch (error) {
            console.log(error.reason)
        }  
    }

    useEffect(() => {
        getWinner();
    }, []); //The empty array means that the useEffect will not enter a loop (or run only once) after the component is mounted.
    return ( 
    <>
        <Alert variant="ghost" className="mt-5" color="blue"><span> Current winner: {winner} 🎉</span></Alert>
    </> 
     );
}
 
export default BidWinner;